module.exports = __webpack_public_path__ + "zmenseni-prsou_7_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zmenseni-prsou_7_after.jpg
// module id = 1289
// module chunks = 0